import { initReactI18next } from 'react-i18next'
import enTranslations from './i18n/en.json'
import plTranslations from './i18n/pl.json'
import i18n from 'i18next'

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: enTranslations,
    },
    pl: {
      translation: plTranslations,
    },
  },
  lng: 'pl',
  fallbackLng: 'pl',
  interpolation: {
    escapeValue: false,
  },
})

export default i18n
